import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import av1 from "../../assests/av1.png";
import av2 from "../../assests/av2.png";
import av3 from "../../assests/av3.png";
import av4 from "../../assests/av4.png";
import av5 from "../../assests/av5.png";

const TopPerformer = () => {
    const data = [
        {
            id: 1,
            name: "Vikas Kumar",
            category: "Solo",
            score: 20,
            rank: 2,
            role: "Red",
            color: "#EF4444",
            avatar: av1,
        },
        {
            id: 2,
            name: "Pallavi Sharma",
            category: "Corporate",
            score: 30,
            rank: 1,
            role: "Blue",
            color: "#3B82F6",
            avatar: av2,
        },
        {
            id: 3,
            name: "Rahul Mehta",
            category: "Corporate",
            score: 5,
            rank: 4,
            role: "Purple",
            color: "#8B5CF6",
            avatar: av3,

        },
        {
            id: 4,
            name: "Arya Singh",
            category: "Web Scenario",
            score: 10,
            rank: 3,
            role: "Yellow",
            color: "#F59E0B",
            avatar: av4,
        },
        {
            id: 5,
            name: "Ranjeet",
            category: "Solo",
            score: 5,
            rank: 5,
            role: "Green",
            color: "#22C55E",
            avatar: av5,
        },
    ];

    return (
        <Box
            sx={{
                p: 3,
                borderRadius: "20px",
                background: "linear-gradient(145deg, #141822, #0F121A)",
                boxShadow: `
          0px 10px 40px rgba(0,0,0,0.7),
          inset 0px 1px 0px rgba(255,255,255,0.05)
        `,
            }}
        >
            {/* Title */}
            <Typography
                sx={{
                    color: "#E5E7EB",
                    fontSize: "22px",
                    fontWeight: 600,
                    mb: 2,
                }}
            >
                Top Performer
            </Typography>

            {/* Table Header */}
            <Stack
                direction="row"
                sx={{
                    px: 2,
                    py: 1.5,
                    borderRadius: "10px",
                    background: "#1A1F2B",
                    color: "#9CA3AF",
                    fontSize: "13px",
                }}
            >
                <Cell fontSize='16px' fontWeight="700" color="#FFFFFF80" width="8%">S.N</Cell>
                <Cell fontSize='16px' fontWeight="700" color="#FFFFFF80" width="28%">Name</Cell>
                <Cell fontSize='16px' fontWeight="700" color="#FFFFFF80" width="18%">Category</Cell>
                <Cell fontSize='16px' fontWeight="700" color="#FFFFFF80" width="14%">Score</Cell>
                <Cell fontSize='16px' fontWeight="700" color="#FFFFFF80" width="12%">Rank</Cell>
                <Cell fontSize='16px' fontWeight="700" color="#FFFFFF80" width="20%">Role</Cell>
            </Stack>

            {/* Rows */}
            <Stack mt={1}>
                {data.map((item, i) => (
                    <Stack
                        key={item.id}
                        direction="row"
                        alignItems="center"
                        sx={{
                            px: 2,
                            py: 1.8,
                            borderBottom: "1px solid rgba(255,255,255,0.06)",
                        }}
                    >
                        <Cell width="8%" dim>
                            {i + 1}
                        </Cell>

                        {/* Name + Avatar */}
                        <Cell width="28%">
                            <Stack direction="row" alignItems="center" gap={1}>
                                <img
                                    src={item.avatar}
                                    alt=""
                                    style={{
                                        width: 28,
                                        height: 28,
                                        borderRadius: "50%",
                                    }}
                                />
                                <Typography
                                    sx={{
                                        color: "#E5E7EB",
                                        fontSize: "14px",
                                    }}
                                >
                                    {truncate(item.name)}
                                </Typography>
                            </Stack>
                        </Cell>

                        <Cell width="18%" dim>
                            {item.category}
                        </Cell>

                        <Cell width="14%" highlight>
                            {item.score}
                        </Cell>

                        <Cell width="12%" dim>
                            {item.rank}
                        </Cell>

                        {/* Role Pill */}
                        <Cell width="20%" >
                            <RoleBadge text={item.role} color={item.color} />
                        </Cell>
                    </Stack>
                ))}
            </Stack>
        </Box>
    );
};

// 🔹 Reusable Cell
const Cell = ({ children, width, dim, highlight }) => (
    <Box sx={{ width }}>
        <Typography
            sx={{
                color: highlight
                    ? "#00E5FF"
                    : dim
                        ? "#9CA3AF"
                        : "#E5E7EB",
                fontSize: "13px",
            }}
        >
            {children}
        </Typography>
    </Box>
);

// 🔹 Role Badge
const RoleBadge = ({ text, color }) => (
    <Box
        sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            px: 2.5,
            py: 0.6,
            borderRadius: "999px",
            background: `${color}15`,
            border: `1px solid ${color}30`,
        }}
    >
        <Box
            sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: color,
            }}
        />
        <Typography sx={{ color: "#E5E7EB", fontSize: "12px" }}>
            {text}
        </Typography>
    </Box>
);

// 🔹 Truncate Name
const truncate = (str) =>
    str.length > 12 ? str.slice(0, 12) + ".." : str;

export default TopPerformer;